module.exports = __webpack_public_path__ + "img/instagram-brands.a5b3083c.svg";